import { render, staticRenderFns } from "./no-results-interactions.vue?vue&type=template&id=683c4638&scoped=true"
var script = {}
import style0 from "./no-results-interactions.vue?vue&type=style&index=0&id=683c4638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c4638",
  null
  
)

export default component.exports